// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__28np_","inputWrap":"Table_inputWrap__2_7VL","col":"Table_col__2wqDe","bmiTooltip":"Table_bmiTooltip__1NSaU"};